import ForgotPasswordView from 'src/pages/forgot-password';
import ResetPasswordView from 'src/pages/reset-password';
import ErrorPage, { Page404, ErrorView } from '../error-page';
import HomeView from '../pages/home';
import LoginView from '../pages/login';
import RegistrationView from '../pages/registration';
import EnterpriseUserPasswordView from 'src/pages/enterprise-user-password';
import DeviceView from 'src/pages/device';

export const routes = [
  {
    path: '/',
    element: <HomeView />,
    errorElement: <ErrorPage />
  },
  {
    path: '/error-view',
    element: <ErrorView />,
    errorElement: <ErrorPage />
  },
  {
    path: '/login',
    element: <LoginView />,
    errorElement: <ErrorPage />
  },
  {
    path: '/registration/:role?/:step?',
    element: <RegistrationView />,
    errorElement: <ErrorPage />
  },
  {
    path: '/forgot-password',
    element: <ForgotPasswordView />,
    errorElement: <ErrorPage />
  },
  {
    path: '/reset-password',
    element: <ResetPasswordView />,
    errorElement: <ErrorPage />
  },
  {
    path: '/enterprise-user-registration',
    element: <EnterpriseUserPasswordView />,
    errorElement: <ErrorPage />
  },
  {
    // Duende's UserInteraction.DeviceVerificationUrl. Changing it means changing that too.
    path: '/device',
    element: <DeviceView />,
    errorElement: <ErrorPage />
  },
  {
    path: '*',
    element: <Page404 />
  }
];
